import React from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./styles/global.scss";
import AppShell from "./components/layout/AppShell";
import ScrollToTop from "./components/common/ScrollToTop";
import ToastRegion from "./components/common/ToastRegion";
import BrandMark from "./components/common/BrandMark";
import siteConfig from "./config/siteConfig";
import { CommerceProvider } from "./context/CommerceContext";
import products from "./data/products";
import AboutPage from "./pages/AboutPage";
import AccessibilityPage from "./pages/AccessibilityPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import NotFoundPage from "./pages/NotFoundPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import PaymentResultPage from "./pages/PaymentResultPage";
import ProductPage from "./pages/ProductPage";
import RecipeDetailPage from "./pages/RecipeDetailPage";
import RecipesPage from "./pages/RecipesPage";
import ReviewsPage from "./pages/ReviewsPage";
import ShopPage from "./pages/ShopPage";
import StaticPage from "./pages/StaticPage";
import TrackOrderPage from "./pages/TrackOrderPage";
import WholesalePage from "./pages/WholesalePage";
import WishlistPage from "./pages/WishlistPage";

const AppRoutes = () => {
  const { pathname } = useLocation();
  const minimalLayout = ["/checkout", "/order-success", "/paysuccess", "/payment"].includes(
    pathname
  );
  const routes = (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/collections/:category" element={<ShopPage />} />
      <Route path="/search" element={<ShopPage mode="search" />} />
      <Route path="/products/:slug" element={<ProductPage />} />
      <Route path="/product/:slug" element={<ProductPage />} />
      <Route path="/shopDetails/:id" element={<ProductPage legacy />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/cartpage" element={<CartPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/order-success" element={<OrderSuccessPage />} />
      <Route path="/paysuccess" element={<OrderSuccessPage />} />
      <Route path="/payment" element={<PaymentResultPage />} />
      <Route path="/wishlist" element={<WishlistPage />} />
      <Route path="/recipes" element={<RecipesPage />} />
      <Route path="/recipes/:slug" element={<RecipeDetailPage />} />
      <Route path="/blogs/recipes" element={<RecipesPage />} />
      <Route path="/blogs/recipes/:slug" element={<RecipeDetailPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/wholesale" element={<WholesalePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      <Route path="/track-order" element={<TrackOrderPage />} />
      <Route path="/shipping" element={<StaticPage slug="shipping" />} />
      <Route path="/returns" element={<StaticPage slug="returns" />} />
      <Route path="/faq" element={<StaticPage slug="faq" />} />
      <Route path="/privacy" element={<StaticPage slug="privacy" />} />
      <Route path="/cookies" element={<StaticPage slug="cookies" />} />
      <Route path="/terms" element={<StaticPage slug="terms" />} />
      <Route path="/accessibility" element={<AccessibilityPage />} />
      <Route
        path="/pages/about-us"
        element={<Navigate to="/about" replace />}
      />
      <Route
        path="/pages/wholesale-spices"
        element={<Navigate to="/wholesale" replace />}
      />
      <Route
        path="/pages/contact-us"
        element={<Navigate to="/contact" replace />}
      />
      <Route path="/pages/:slug" element={<StaticPage />} />
      <Route path="/journal" element={<Navigate to="/recipes" replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );

  if (minimalLayout) {
    return (
      <div className="minimal-shell">
        <a className="skip-link" href="#main-content">
          Skip to main content
        </a>
        <header className="minimal-shell__header">
          <BrandMark showTagline />
        </header>
        <main className="app-shell__main" id="main-content" tabIndex="-1">
          {routes}
        </main>
      </div>
    );
  }

  return <AppShell products={products}>{routes}</AppShell>;
};

function App() {
  return (
    <CommerceProvider
      products={products}
      freeShippingThreshold={siteConfig.shipping.freeThreshold}
      shippingRate={siteConfig.shipping.standardRate}
    >
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <ScrollToTop />
        <AppRoutes />
        <ToastRegion />
      </BrowserRouter>
    </CommerceProvider>
  );
}

export default App;
